import { Pill, Price } from '@vfit/shared/atoms';
import { colors, purify } from '@vfit/shared/themes';
import { IProductOfferCard } from './productOfferCard.model';
import * as S from './productOfferCard.style';

export const ProductOfferCard = ({
  pill,
  title,
  price,
  info,
  variant = 'resh',
}: IProductOfferCard) => {
  const [pInfo] = purify([info]);

  return (
    <div>
      {pill?.label &&
        (variant === 'resh' ? (
          <S.TextPill>{pill?.label}</S.TextPill>
        ) : (
          <S.WrapPill variant={variant}>
            <Pill
              label={pill?.label || ''}
              pillsColor={pill?.color || colors.$25282B}
              opacity={pill?.opacity || 100}
            />
          </S.WrapPill>
        ))}

      {title && <S.Title variant={variant}>{title}</S.Title>}

      {(price?.price || price?.freeAmountRecurrence) && (
        <Price
          variant={variant === 'resh' ? 'details' : 'mva:details'}
          label={price?.label}
          amount={price?.price || ''}
          oldAmount={price?.originalPrice}
          recurrence={price?.recurrence}
          freeAmountRecurrence={price?.freeAmountRecurrence}
        />
      )}

      {pInfo && (
        <S.Info
          variant={variant}
          dangerouslySetInnerHTML={{
            __html: pInfo,
          }}
        />
      )}
    </div>
  );
};
